import { SET_ERROR } from "@/store/mutations-types";

type Commit = (_type: string, _payload?: any) => void;

interface ErrorPayload {
  title: string;
  message?: string;
  status: number;
  error: any;
}

export function throwError(
  commit: Commit,
  title: string,
  message?: string
): (_error?: any) => never {
  return (error?: any) => {
    const status = error && error.response ? error.response.status : 0;
    const payload: ErrorPayload = {
      title,
      message,
      status,
      error,
    };
    commit(SET_ERROR, payload);
    throw error || new Error(message || title);
  };
}

export function getStateProperty(state: Record<string, any>, ref: string | string[]): any {
  if (!ref) {
    throw Error(`State ref empty: ${ref}`);
  }

  const path = Array.isArray(ref) ? ref : ref.split(".");
  let property = state;

  // eslint-disable-next-line no-constant-condition
  while (true) {
    const propKey = path.shift();
    if (!propKey || !property[propKey]) {
      break;
    }
    property = property[propKey];
  }

  if (property === state) {
    throw Error(`State property not found: ${ref}`);
  }

  return property;
}
